/* Copyright 2014-2018 The MathWorks, Inc. */

define([
    "dojo/_base/lang",
    "MW/statusbar/WidgetClassHash",
    "MW/toolstrip/hashes/WidgetClassHash",
    "mw-log/Log"
], function (lang, StatusWidgetClassHash, ToolstripWidgetClassHash, Log) {

    var hash = lang.mixin(lang.clone(StatusWidgetClassHash), ToolstripWidgetClassHash);

    return {
        create: function (args) {
            var result;
            if (hash[args.type]) {
                result = new hash[args.type](args);
            } else {
                Log.error("No corresponding constructor found for type " + args.type);
            }
            return result;
        },

        addClass: function(type, clazz) {
            hash[type] = clazz;
        }
    };
});